import Svg from '../generated/Search';
import { Icon, type IconProps } from './Icon';

export const SearchIcon = (props: IconProps) => <Icon component={Svg} name="search" {...props} />;
